import { ReduxUtils } from '../../../dependencies';
import { types } from '../../actions';

const actionTypes = {
    REQUEST: types.CREATE_SERVICE_KEY_REQUEST,
    SUCCESS: types.CREATE_SERVICE_KEY_SUCCESS,
    FAILURE: types.CREATE_SERVICE_KEY_FAILURE,
    CANCEL: types.CREATE_SERVICE_KEY_CANCEL,
};

export default ReduxUtils.basicApiReducer({
    actionTypes,
});
